import React from "react";

function Hero() {
  return (
    <div>
      <div className="relative h-screen">
        <img
          src="/images/hero.jpg"
          alt="Koon"
          className="absolute inset-0 w-full h-full object-cover image-large"
        />

        <img
          src="/images/hero_2.jpg"
          alt="Koon Small"
          className="absolute inset-0 w-full h-full object-cover image-small"
        />

        <div className="hero_txt">
          <p>Koon</p>
        </div>
        <div className="button_hero">
          <a
            href="#donation"
            rel="noopener noreferrer"
            className="font-bold button"
          >
            Make a donation
          </a>
        </div>
      </div>
    </div>
  );
}

export default Hero;
